import React from 'react';
import { Button } from './ui/button';
import { AlertCircle, Phone } from 'lucide-react';

const EmergencySection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-amber-900/20 via-gray-950 to-gray-950 border-y border-amber-600/20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="p-4 bg-amber-600/20 rounded-full animate-pulse">
            <AlertCircle className="w-12 h-12 text-amber-500" />
          </div>
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          We're Always Ready When You Need Us
        </h2>

        <p className="text-xl text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto">
          We're always available, making sure your problems are handled quickly and efficiently 
          whenever they arise. Our fully equipped, on-call engineers are ready to tackle any 
          issue with speed, precision, and professionalism.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            onClick={scrollToContact}
            size="lg"
            className="bg-amber-600 hover:bg-amber-700 text-white px-10 py-6 text-lg rounded-md transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/40 flex items-center justify-center space-x-2"
          >
            <Phone className="w-5 h-5" />
            <span>Request Emergency Service</span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EmergencySection;
